import * as React from 'react';
import { useReducer, useEffect } from 'react';
import fetchAPI from '../utils/fetchAPI';
import { useSettingsContext } from './settings';

const actions = {
	SET_TAX_OPTIONS: 'SET_TAX_OPTIONS',
	SELECT_TAX_TERM: 'SELECT_TAX_TERM',
	CLEAR_FILTERS: 'CLEAR_FILTERS',
	SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
};

const reducer = (state, action) => {
	switch (action.type) {
		case actions.SET_TAX_OPTIONS: {
			return {
				...state,
				tax: action.payload,
			};
		}
		case actions.SET_SEARCH_QUERY: {
			return {
				...state,
				searchQuery: action.payload,
			};
		}

		case actions.SELECT_TAX_TERM: {
			const selectedTax = { ...state.selectedTax };
			if (action.payload.term !== '') {
				selectedTax[action.payload.tax] = action.payload.term;
			} else if ('undefined' !== typeof selectedTax[action.payload.tax]) {
				delete selectedTax[action.payload.tax];
			}

			return {
				...state,
				selectedTax,
			};
		}

		case actions.CLEAR_FILTERS: {
			return {
				...state,
				selectedTax: state.initSelectedTax,
				searchQuery: '',
			};
		}

		default: {
			return state;
		}
	}
};

const FiltersContext = React.createContext();

const FiltersProvider = ({ children }) => {
	const settings = useSettingsContext();

	const initialState = {
		searchQuery: '',
		tax: {},
		selectedTax: settings.initSelectedTax,
		initSelectedTax: settings.initSelectedTax,
	};

	const [state, dispatch] = useReducer(reducer, initialState);

	useEffect(() => {
		if (settings.filtersToShow.length) {
			const fetchData = async () => {
				const response = await fetchAPI(
					`${settings.apiBase}/get-taxonomies?post_type=${
						settings.postType
					}&tax=${settings.filtersToShow.join(',')}`
				);
				dispatch({ type: actions.SET_TAX_OPTIONS, payload: response });
			};

			// eslint-disable-next-line no-console
			fetchData().catch(console.error);
		}
	}, [settings.apiBase, settings.filtersToShow, settings.postType]);

	const value = {
		tax: state.tax,
		selectedTax: state.selectedTax,
		searchQuery: state.searchQuery,
		selectTaxTerm: (tax, term) => {
			dispatch({ type: actions.SELECT_TAX_TERM, payload: { tax, term } });
		},
		setSearchQuery: (query) => {
			dispatch({ type: actions.SET_SEARCH_QUERY, payload: query });
		},
		clearFilters: () => {
			dispatch({ type: actions.CLEAR_FILTERS });
		},
	};

	return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};

const useFiltersContext = () => React.useContext(FiltersContext);

export { FiltersProvider, useFiltersContext };
